import fetch from 'services/request';

const shopApis = {
  categories: () => fetch({ url: '/api/v1/category/all-category' }),
  getAllProductByCategory: () =>
    fetch({
      method: 'get',
      url: '/api/v1/product/all-by-category',
    }),
  checkPassCode: (code: string) => fetch({ url: `/api/v1/staff/check-pass-code/${code}` }),
  checkAdminPassCode: (code: string) => fetch({ url: `/api/v1/staff/verify-admin-code/${code}` }),
  getStaffs: () => fetch({ url: '/api/v1/staff/all' }),
  settingTax: () => fetch({ url: '/api/v1/setting/setting-tax' }),
  feeCreditCard: () => fetch({ url: '/api/v1/setting/fee-credit-card' }),
  cashIncentive: () => fetch({ url: '/api/v1/setting/cash-discount-incentive' }),
  shopInfo: () => fetch({ url: '/api/v1/store/detail', }),
  paymentOthers: () => fetch({ url: '/api/v1/setting/payment-others', }),
  loyaltyProgram: () => fetch({ url: '/api/v1/setting/get-loyalty-program', }),
  packageVip: () => fetch({ url: '/api/v1/setting/package-vip', }),
};

export default shopApis;
